import moment from 'moment';

const currentShopUrl = ''; //TODO
// 补全图片链接完整
export const completePictureLink = (src) => {
  if (!src) {
    return '';
  }
  if (src.includes('http') || src.includes('https')) {
    return src;
  }
  if (src.includes('jfs')) {
    return `//img13.360buyimg.com/applylogo/${src}`;
  }
};

export function gotoNewUnitedEnrollManagePage(mcActivityId) {
  window.open(`${currentShopUrl}/uniteActivity/enrollManage/${mcActivityId}`);
}

export function showTime(time) {
  let start = moment(); //获取开始时间
  let end = moment(time); //结束时间
  let diff = end.diff(start); //时间差
  let timediff = Math.round(diff / 1000);
  //获取还剩多少天
  let day = parseInt(timediff / 3600 / 24);
  //获取还剩多少小时
  let hour = parseInt((timediff / 3600) % 24);
  //获取还剩多少分钟
  let minute = parseInt((timediff / 60) % 60);
  //获取还剩多少秒
  let second = timediff % 60;
  //给小于10的数值前面加 0
  function timerFilter(params) {
    if (params - 0 < 10) {
      return '0' + params;
    } else {
      return params;
    }
  }
  return {
    day: timerFilter(day),
    hour: timerFilter(hour),
    minute: timerFilter(minute),
    second: timerFilter(second),
  };
}
